import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default function setBannerLinha() {
  const banner = document.querySelector('[data-banner-linha]');

  if (banner) {
    const carousel = banner.querySelector('.swiper');
    const next = banner.querySelector('.swiper-button-next');
    const prev = banner.querySelector('.swiper-button-prev');

    new Swiper(carousel, {
      modules: [Navigation],
      slidesPerView: 1.1,
      spaceBetween: 0,
      watchOverflow: true,
      speed: 1000,
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1280: {
          slidesPerView: 3,
        },
      },
    });
  }
}
